import React, { Component } from "react";
import NewsItem from "./NewsItem";
import Spinner from "./Spinner";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";

export class News extends Component {
  static defaultProps = {
    country: "us",
    pageSize: 8,
    category: "general",
  };

  static propTypes = {
    country: PropTypes.string,
    pageSize: PropTypes.number,
    category: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      articles: [],
      loading: true,
      page: 1,
      totalResults: 0,
    };
  }

  async updateNews() {
    this.setState({ loading: true });

    const url = `/api/news?country=${this.props.country}&category=${this.props.category}&page=${this.state.page}&pageSize=${this.props.pageSize}`;

    const data = await fetch(url);
    const parsedData = await data.json();

    this.setState({
      articles: parsedData.articles,
      totalResults: parsedData.totalResults,
      loading: false,
    });
  }

  async componentDidMount() {
    this.updateNews();
  }

  handlePrevClick = async () => {
    await this.setState({ page: this.state.page - 1 });
    this.updateNews();
  };

  handleNextClick = async () => {
    await this.setState({ page: this.state.page + 1 });
    this.updateNews();
  };

  fetchMoreData = async () => {
    const nextPage = this.state.page + 1;
    const url = `/api/news?country=${this.props.country}&category=${this.props.category}&page=${nextPage}&pageSize=${this.props.pageSize}`;

    const data = await fetch(url);
    const parsedData = await data.json();

    this.setState({
      page: nextPage,
      articles: this.state.articles.concat(parsedData.articles),
      totalResults: parsedData.totalResults,
    });
  };

  //   render() {
  //     return (
  //       <>
  //         <p style={{ textAlign: "center" }}>
  //           loading: {String(this.state.loading)} | articles:{" "}
  //           {this.state.articles.length}
  //         </p>

  //         <h1 className="text-center" style={{ margin: "40px 0px" }}>
  //           TheChronicles - Top Headlines
  //         </h1>

  //         {this.state.loading && <Spinner />}

  //         {!this.state.loading && this.state.articles.length === 0 && (
  //           <p className="text-center mt-5">
  //             No news available for this category.
  //           </p>
  //         )}

  //         {this.state.articles.length > 0 && (
  //           <InfiniteScroll
  //             dataLength={this.state.articles.length}
  //             next={this.fetchMoreData}
  //             hasMore={this.state.articles.length < this.state.totalResults}
  //             loader={<Spinner />}
  //           >
  //             <div className="container">
  //               <div className="row">
  //                 {this.state.articles.map((element) => (
  //                   <div className="col-md-4" key={element.url}>
  //                     <NewsItem
  //                       title={element.title || ""}
  //                       description={element.description || ""}
  //                       imageUrl={element.image}
  //                       newsUrl={element.url}
  //                       author={element.author}
  //                       date={element.publishedAt}
  //                       source={element.source.name}
  //                     />
  //                   </div>
  //                 ))}
  //               </div>
  //             </div>
  //           </InfiniteScroll>
  //         )}
  //       </>
  //     );
  //   }

  render() {
    return (
      <div style={{ marginTop: "90px" }}>
        <h1 className="text-center" style={{ margin: "40px 0px" }}>
          TheChronicles - Top Headlines
        </h1>

        {this.state.loading && <Spinner />}

        {!this.state.loading && (this.state.articles || []).length === 0 && (
          <p className="text-center mt-5">
            No news available for this category.
          </p>
        )}

        {(this.state.articles || []).length > 0 && (
          <InfiniteScroll
            dataLength={(this.state.articles || []).length}
            next={this.fetchMoreData}
            hasMore={false}
            loader={<Spinner />}
          >
            <div className="container">
              <div className="row">
                {this.state.articles.map((element, index) => (
                  <div className="col-md-4" key={index}>
                    <NewsItem
                      title={element.title || ""}
                      description={element.description || ""}
                      imageUrl={element.image}
                      newsUrl={element.url}
                      author={element.source?.name}
                      date={element.publishedAt}
                      source={element.source?.name}
                    />
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        )}
      </div>
    );
  }
}

export default News;
